export default __webpack_public_path__ + "static/media/mainImg-png.a1be85d7.png";